import { lazy, Suspense } from "react"
import Loader from '../custom/loader/main' 

const Main = lazy(() => import('../components/report/pendingApproval/main'))
const PendingApproval = () =>{
    return(

        <Suspense fallback={<Loader/>}>
            <Main/>
        </Suspense>  
    )
}

export default PendingApproval